import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, Alert } from "~/components-shared";
import { StatusStateEnum } from "~/types/enums";
import { useDispatch, useSelector } from "react-redux";
import onboardingActionCreators from "~/store/onboarding/actions";
import { handleError } from "~/lib/helpers";
import onboardingSelectors from "~/store/onboarding/selectors";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TopicOnboardingForm from "~/forms/TopicOnboardingForm";
import topicOnboardingSchema from "~/forms/TopicOnboardingForm/topicOnboardingSchema";
import api from "~/lib/api";
const Actions = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  margin-top: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.step * 5;
}}px;
  margin-bottom: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.step * 2;
}}px;
`;
const OnboardingTopicsIdentify = _ref3 => {
  let {
    onSuccess,
    ...rest
  } = _ref3;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [template, setTemplate] = useState();
  const {
    t
  } = useTranslation();
  const status = useSelector(onboardingSelectors.getStatus);
  const onboardingDefaultValues = {
    name: "",
    description: ""
  };
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    resolver: yupResolver(topicOnboardingSchema),
    defaultValues: onboardingDefaultValues
  });
  const onSkip = () => {
    dispatch(onboardingActionCreators.companyTopicsSkipStarted());
  };
  const onOnboardingSubmit = handleSubmit(data => {
    if (template) {
      onSuccess(template);
    } else {
      setIsLoading(true);
      setError("");
      api.generateTopicTemplate(data).then(generatedTemplate => onSuccess(generatedTemplate)).catch(e => setError(handleError(e))).finally(() => setIsLoading(false));
    }
  });
  return /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: onOnboardingSubmit
  }, rest), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(TopicOnboardingForm, {
    control: control,
    setValue: setValue,
    setTemplate: selectedTemplate => setTemplate(selectedTemplate)
  }), /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onSkip,
    color: "grey",
    s: {
      px: 8
    },
    disabled: isLoading,
    rounded: true
  }, t("common.actions.skip")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onOnboardingSubmit,
    loading: isLoading || status === StatusStateEnum.LOADING,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true,
    shadow: true
  }, t("common.actions.continue"))));
};
export default OnboardingTopicsIdentify;